import { render, staticRenderFns } from "./MoneyUnitSelect.vue?vue&type=template&id=20781c24&"
import script from "./MoneyUnitSelect.ts?vue&type=script&lang=ts&"
export * from "./MoneyUnitSelect.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports